import { render, staticRenderFns } from "./print_fees_defaulters.vue?vue&type=template&id=29fbfaaa&scoped=true&"
import script from "./print_fees_defaulters.vue?vue&type=script&lang=js&"
export * from "./print_fees_defaulters.vue?vue&type=script&lang=js&"
import style0 from "./print_fees_defaulters.vue?vue&type=style&index=0&id=29fbfaaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fbfaaa",
  null
  
)

export default component.exports